<div class="payment-order-payment-method">
  @if(displayMode() === 'detailed') {
  <div class="payment-folder-payment-header">
    <app-validated-form-row
      [isRemoveHidden]="true"
      [isEditHidden]="isEditMode()"
      (edit)="onEdit()"
      data-cy="edit-refund-method"
    >
      <ng-template #labelTemp>
        <ng-container>
          <h5>{{ selectionTitle() | translate }}</h5>
        </ng-container>
      </ng-template>
    </app-validated-form-row>
  </div>
  @if(isEditMode()) {
  <div class="payment-folder-payment-value-inprogress">
    <app-payment-mode-form
      appendTo="body"
      [formGroup]="form()"
      [modes]="paymentModes$() | async"
      [hiddenPaymentTypes]="true"
      [paymentTypes]="paymentTypes()"
      [totalAmount]="totalAmount$() | async"
      (amountToReturnChange)="onAmountToReturnChange($event)"
      data-cy="refund-payment-mode"
    >
      <ng-template #paymentActions> </ng-template>
    </app-payment-mode-form>
  </div>
  }@else{ @for (mode of cancelPaymentModes(); track mode.paymentTypeLabel; let i = $index) {
  <div class="payment-folder-payment-value">
    <app-validated-form-row
      [isEditHidden]="true"
      [isRemoveHidden]="true"
      [formIndex]="i"
      (edit)="onEdit()"
      data-cy="edit-payment-mode"
    >
      <ng-template #labelTemp>
        <div class="amount-wrapper">
          <span class="label-item-bold">
            {{ mode.paymentTypeLabel }}
          </span>
          <span class="label-item"> - {{ mode.amount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }} </span>
        </div>
      </ng-template>
    </app-validated-form-row>
    @if(i !== cancelPaymentModes()?.length - 1) {
    <hr />
    }
  </div>
  } } }@else {
  <div class="payment-order-payment-methode p-2">
    <div class="payment-order-payment-multiple">
      <div class="payment-order-payment-label">{{ 'orders.info.selectRefundMethod' | translate }}</div>
      <div class="payment-order-payment-value" id="refund-mode-dropdown">
        <app-dropdown-list
          [ngModel]="selectedPaymentMode()"
          (ngModelChange)="onPaymentModeChange($event)"
          [items]="availablePaymentModes()?.length ? availablePaymentModes() : (paymentModes$() | async)"
          placeholder="orders.typeOfPayment"
          bindLabel="name"
          [canSelectMulti]="false"
          [closeOnSelect]="true"
          styleClass="ng-select-sm"
          data-cy="refund-mode-dropdown"
        >
          <ng-template #customOption let-item="item">
            <div [attr.data-cy]="item?.name">{{ item?.name }}</div>
          </ng-template>
        </app-dropdown-list>
      </div>
    </div>
  </div>
  }
</div>
